/**
 * Werktags-Helfer (Mo–Fr). Bewusst OHNE Feiertage — konsistent zur
 * Backend-TWV-Auto-Roll-Logik (todo-rollover.service.ts: Cron Mo–Fr,
 * „Feiertage werden bewusst NICHT berücksichtigt").
 */

/** Samstag (6) oder Sonntag (0)? */
export function isWeekend(date: Date): boolean {
  const d = date.getDay();
  return d === 0 || d === 6;
}

/** Nächster Werktag NACH `from` (überspringt Sa/So). `from` selbst zählt nicht. */
export function nextBusinessDay(from: Date = new Date()): Date {
  const d = new Date(from);
  do {
    d.setDate(d.getDate() + 1);
  } while (isWeekend(d));
  return d;
}

/** `from` + `days` Werktage (Sa/So werden übersprungen). days<=0 → Kopie von `from`. */
export function addBusinessDays(from: Date, days: number): Date {
  const d = new Date(from);
  let remaining = Math.max(0, Math.floor(days));
  while (remaining > 0) {
    d.setDate(d.getDate() + 1);
    if (!isWeekend(d)) remaining--;
  }
  return d;
}

/** Lokales YYYY-MM-DD für `<input type="date">` (kein UTC-Versatz). */
export function toDateInputValue(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
